export function LoadingScreen({
  message = 'Adjusting everything to your liking...',
}: {
  message?: string;
}) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-white">
      <div className="flex items-center gap-3">
        <Spinner />
        <p className="text-[14px] font-normal leading-[20px] text-[#A5A5A5]">{message}</p>
      </div>
    </div>
  );
}

function Spinner() {
  return (
    <div
      className="size-6 animate-spin rounded-full border-2 border-[#E5E5E5] border-t-[#1F1F1F]"
      role="status"
      aria-label="Loading"
    />
  );
}
